import React from 'react';

export interface JourneyFieldShellProps {
  label?: React.ReactNode;
  children: React.ReactNode;
  error?: React.ReactNode;
  className?: string;
  htmlFor?: string;
  required?: boolean;
  as?: 'label' | 'div' | 'fieldset';
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneyFieldShell: React.FC<JourneyFieldShellProps> = ({
  label,
  children,
  error,
  className,
  htmlFor,
  required = false,
  as = 'label',
}) => {
  const fieldClassName = cx(
    'form-field',
    Boolean(error) && 'has-error',
    className,
  );

  if (as === 'fieldset') {
    return (
      <fieldset className={fieldClassName}>
        {label ? (
          <legend className="form-label">
            {label}
            {required ? '*' : ''}
          </legend>
        ) : null}
        {children}
        {error ? <span className="form-error">{error}</span> : null}
      </fieldset>
    );
  }

  if (as === 'div') {
    return (
      <div className={fieldClassName}>
        {label ? (
          <label className="form-label" htmlFor={htmlFor}>
            {label}
            {required ? '*' : ''}
          </label>
        ) : null}
        {children}
        {error ? <span className="form-error">{error}</span> : null}
      </div>
    );
  }

  return (
    <label className={fieldClassName} htmlFor={htmlFor}>
      {label ? (
        <span className="form-label">
          {label}
          {required ? '*' : ''}
        </span>
      ) : null}
      {children}
      {error ? <span className="form-error">{error}</span> : null}
    </label>
  );
};

export const FormField = JourneyFieldShell;

export default JourneyFieldShell;
